<template lang="html">
  <section class="about">
    <h1>About Component</h1>
  </section>
</template>

<script lang="js">
export default {
  name: 'About',
  props: [],
  components: {
    // Loader,
  },
  setup(props) {
    return {};
  },
};
</script>
